<template>
    <div class="level is-mobile">
        <div class="level-left">
            <h1 class="title is-5">Volunteers</h1>
        </div>
    </div>

    <div v-if="volunteers">
        <div v-if="volunteers.length > 0">
            <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Location</th>
                    <th>Role</th>
                </tr>
            </thead>
            <tbody>
                <VolunteerViewItem v-for="volunteer in volunteers" :key="volunteer.id" :id="volunteer.id" :fdID="this.fdID"
                    :name="volunteer.name" :location="volunteer.location" :role="volunteer.role" :canBeHelper="volunteer.can_be_helper"
                    :withHelper="volunteer.with_helper" :team="volunteer.team" :volunteerType="volunteer.volunteer_type">
                </VolunteerViewItem>
            </tbody>
        </table>
        </div>
        <div v-else>
            Zero registrations.
        </div>
    </div>
</template>

<script>
import VolunteerViewItem from './VolunteerViewItem.vue';

export default {
    components: {
        VolunteerViewItem
    },
    props: ['fdID'],
    computed: {
        volunteers() {
            return this.$store.getters['volunteer/getVolunteers'];
        },
        currentFDID() {
            return this.$store.getters['fd/getCurrentFDID'];
        }
    },
    mounted() {
        this.$store.dispatch('volunteer/subscribeVolunteers', this.currentFDID);
    },
    unmounted() {
        this.$store.dispatch('volunteer/unsubscribeVolunteers');
    }
}
</script>
